import React, {createContext, useContext} from 'react';

import {imageUrl} from '../../../image-url';

import css from '../../markdown.module.css';

export type MarkdownImageProps = {
	/** якорь картинки: по нему её правят и на неё ссылаются */
	id?: string;
	/** путь в dnd2-images: `books/tod/map-1.webp` */
	src?: string;
	width?: string;
	height?: string;
	author?: string;
	caption?: string;
	/** сторона обтекания вытянутой картинки: left или right */
	side?: string;
	/** картинка стоит в ряду с соседними: `true` */
	inRow?: string;
	/** `false` — оформление, а не иллюстрация: без увеличения и без места в галерее */
	gallery?: string;
};

/**
 * Страница может нарисовать картинку по-своему: книга добавляет галерею, обтекание и кнопки правки.
 * Без неё картинка рисуется простой фигурой с подписью.
 */
export const MarkdownImageContext = createContext<((image: MarkdownImageProps) => React.ReactNode) | null>(null);

/** Картинка в тексте: `[img id="…" src="…" width="…" height="…" author="…" caption="…" /]` */
export const MarkdownImage: React.FC<MarkdownImageProps> = (props) => {
	const render = useContext(MarkdownImageContext);
	if (render) return <>{render(props)}</>;

	const {id, src, width, height, caption} = props;
	if (!src) return null;
	return (
		<figure className={css.figure} id={id}>
			<img
				src={imageUrl(src, 900)}
				width={width ? Number(width) : undefined}
				height={height ? Number(height) : undefined}
				alt={caption || ''}
				loading="lazy"
				decoding="async"
			/>
			{caption && <figcaption className={css.figureCaption}>{caption}</figcaption>}
		</figure>
	);
};
